<template>
  <div>
    <el-table :data="blockInfoList"  size="small" border>
      <el-table-column prop="id" width="140px" label="ID" fixed show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
         
        </template>
      </el-table-column>
      <el-table-column prop="coin" width="120px" label="币种" fixed>
        <template slot-scope="scope">{{
          scope.row.coin
        }}</template>
      </el-table-column>
      <el-table-column prop="chain" width="120px" label="币种的链" fixed>
        <template slot-scope="scope">
          <span v-if="scope.row.chain">{{scope.row.chain}}</span>
          <span v-else>--</span>
          
        </template>
      </el-table-column>
      <el-table-column width="180px" prop="hash" label="hash" show-overflow-tooltip>
        <template slot-scope="scope">
          <a >{{scope.row.hash}}</a>
        </template></el-table-column>
      <el-table-column width="180px" prop="blockHash" label="blockHash" show-overflow-tooltip>
        <template slot-scope="scope">
          <a >{{scope.row.blockHash}}</a>
        </template></el-table-column>
        <el-table-column prop="blockTime" label="区块时间" width="120">
        <template slot-scope="scope">
          <span >{{
       scope.row.blockTime
          }}</span>
         
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="数量" width="120">
        <template slot-scope="scope">
          <span >{{
            scope.row.amount
          }}</span>
         
        </template>
      </el-table-column>
     <el-table-column prop="fee" label="手续费" width="100">
      
     </el-table-column>
     <el-table-column prop="fromAccountOrAddress" label="from地址" width="120" show-overflow-tooltip>
      <template slot-scope="scope">
          <a >{{scope.row.fromAccountOrAddress}}</a>
        </template>
     </el-table-column>
     <el-table-column prop="toAddress" label="to地址" width="120" show-overflow-tooltip>
      <template slot-scope="scope">
        <a >{{scope.row.toAddress}}</a>
      </template>
     
     </el-table-column>
      <el-table-column prop="paymentCategory" label="付款类别" width="150">
        <template slot-scope="scope">
          <span v-if="scope.row.paymentCategory=='receive'">充值（平台地址接受）</span>
          <span v-else-if="scope.row.paymentCategory=='send'">提现（平台地址发送）</span>
          <span v-else-if="scope.row.paymentCategory=='tocold'">转冷</span>
          <span v-else-if="scope.row.paymentCategory=='tocoldfee'">转冷手续费</span>
          <span v-else>冷钱包到热钱包</span>
        </template>
      </el-table-column>
      <el-table-column prop="status" width="120px" label="区块状态">
        <template slot-scope="scope">
          <el-tag   v-if="scope.row.status=='CONFIRMED'">{{ scope.row.status }}</el-tag>
          <el-tag  type="danger" v-else-if="scope.row.status=='pending'">{{ scope.row.status }}</el-tag>
          <el-tag  type="success" v-else-if="scope.row.status=='success'">{{ scope.row.status }}</el-tag>
          <el-tag  type="warning" v-else-if="scope.row.status=='CONFIRMING'">{{ scope.row.status }}</el-tag>
          <!-- <el-tag  type="warning" v-else-if="scope.row.status=='CONFIRMING'">{{ scope.row.status }}</el-tag> -->
          <!-- <el-tag  type="info" v-else>未知状态</el-tag> -->
        </template>
      </el-table-column>
      <el-table-column width="120px" label="块编号或位置">
        <template slot-scope="scope">
          <el-tag >{{ scope.row.blockNumberOrPosition }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="isFinished" label="是否完成状态" width="120px" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isFinished">是</el-tag>
          <el-tag type="danger" v-else>否</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="disposeStatusInner" label="内部状态" width="120px">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.disposeStatusInner=='SUCCESS'">成功</el-tag>
          <el-tag type="danger" v-else-if="scope.row.disposeStatusInner=='FAIL'">失败</el-tag>
          <el-tag v-else-if="scope.row.disposeStatusInner=='EXECUTING_DISPOSE'">正在执行中</el-tag>
          <el-tag v-else-if="scope.row.disposeStatusInner=='FAIL_CANNOT_RETRY'">失败不能重试</el-tag>
          <el-tag v-else-if="scope.row.disposeStatusInner=='REPEAT_CANNOT_RETRY'">重复不能重试</el-tag>
          <el-tag v-else-if="scope.row.disposeStatusInner=='UNSUPPORTED_TRANSACTION'">不支持此交易</el-tag>
          <el-tag type="warning" v-else="scope.row.disposeStatusInner=='WAITING_FOR_CONFIRMATION'">等待确认中</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="auditStatus" label="审核状态" width="120px">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.auditStatus==0">待审核</el-tag>
          <el-tag type="success" v-else-if="scope.row.auditStatus==1">已审核</el-tag>
          <el-tag type="danger" v-else>异常数据</el-tag>
         
        </template>
      </el-table-column>
      <el-table-column prop="source" label="来源" width="120px">
        <template slot-scope="scope">
          <span v-if="scope.row.source">{{ scope.row.source }}</span>
          <span v-else>暂无</span>
        </template>
      </el-table-column>
      <el-table-column label="编辑" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-edit"
            circle
            @click="handleUpdate(scope.row)"
          ></el-button>
          <el-button
            size="mini"
            type="danger"
            icon="el-icon-delete"
            circle
            @click="handleDel(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="size"
      :total="totalCount"
      :page="page"
      @pageChanged="pageChanged"
    ></pagination>
    <update-dialog :val="userinfoDetail"  ></update-dialog>
  
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import updateDialog from '../updatedialog';

export default {
  name: 'BlockListData',
 
  data() {
    return {
      page:1,size:25,
    };
  },
  components: {
    Pagination,
    updateDialog
  },
  methods: {
    ...mapActions('blockInfo', ['delOne']),
    ...mapMutations('blockInfo', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail'
    ]),
    pageChanged(pagination) {
      this.page=pagination.page
      this.size=pagination.size
      this.$emit('refresh', pagination);
    },
    handleDel(row){
      this.$confirm('此操作将永久删除该配置, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.delOne(row.id).then(res=>{
            if(res.code==0){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
            }
            this.$emit('refresh', {page:this.page,size:this.size});
          })
         
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    handleUpdate(selected) {
      this.setUserinfoDetail(selected);
      this.setUserinfoDetailDialogVisible(true);
    },
   
  },
  computed: {
    ...mapState('blockInfo', [
      'pagination',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible','blockInfoList'
    ])
  }
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: red;
  font-weight: bold;
}
</style>
